export default function FrontCard2(props){
    return <>
        <div className="card border-success shadow bg-light p-3 hover-blink h-100" style={{ fontStyle: "italic", textAlign: "justify" }} >
              <div className="card-body text-justify">
                "{props.children}"
              </div>
            <div className="card-title text-secondary text-end"> - {props.title} </div>
        </div>
    </>
}